import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Product } from '../../models/Product';
import { TranslateService } from '@ngx-translate/core';
import utils from '../../utils';

@Component({
  selector: 'app-replace-product-view',
  templateUrl: './replace-product-view.component.html',
  styleUrls: ['./replace-product-view.component.scss'],
  standalone: false,
})
export class ReplaceProductViewComponent implements OnInit {
  i18n = inject(TranslateService);

  @Input('product') product: Product;
  @Input('image') image: string;
  @Input('isAdd') isAdd = false;
  @Input() merchant: any;

  @Output() replace: EventEmitter<string> = new EventEmitter();

  ngOnInit() {}

  emitReplace() {
    this.replace.emit(this.product._id);
  }

  protected readonly utils = utils;
}
